import { render, staticRenderFns } from "./ElecTestDrive.vue?vue&type=template&id=348ccab7"
import script from "./ElecTestDrive.vue?vue&type=script&lang=js"
export * from "./ElecTestDrive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports